import GET_ARTICLES from "../plugins/getArticles"

const [ w, d ] = [ window, document ]

const init = () => {


    $.when( w.load['brand'] ).then( () => {
      let makeItem = item => $(`
        <div id="brand-${item.id}" class="brand-item" href="${item.href}">
          <figure class="brand-item__img">
            <img src="${item.thumb}" alt="${item.title}" width="160" loading="lazy">
          </figure>
          <div class="brand-item__body">
            <h4 class="name">${item.title}</h4>
            <span class="desc">${item.desc}</span>
            <div class="body">${item.body}</div>
          </div>

        </div>
        `)[0]
      GET_ARTICLES('.brand-list[data-plugin="getArticles"]', { makeItem }).then(() => {
        // ハッシュURLでスクロール
        (function(_){
          const scroll_screen = () => {
            if(_.hash != '' && $(_.hash).length ){
              var pos = $(_.hash).offset().top;
              if( _.mq.matches ){
                var headerHeight = $('header#header').height();
                pos = (pos - parseInt( headerHeight ) );
              }
              setTimeout(()=> _.$target.animate({scrollTop:pos},200,'easeInOutExpo'), 200)
            }
          }
          scroll_screen()
          w.load['loadHtml'].then( scroll_screen )
        }({
          hash:location.hash,
          $target:$('body,html'),
          mq : w.matchMedia( "(max-width: 900px)" )
        }));
      })
    })
}

export default function BRAND() {
  $( init )
}